var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":""}},[_c('section',{staticClass:"main"},[_c('TheHeader'),_c('HeaderPage',{attrs:{"title":"Recados"}}),_c('div',{staticClass:"flex"},[_vm._v(" Content ")]),_c('TheFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }